import { render } from "./AddPress.vue?vue&type=template&id=3eb1f6d6"
import script from "./AddPress.vue?vue&type=script&lang=js"
export * from "./AddPress.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Projects\\Logica Yachts\\Front\\Logica-Yachts\\Dashboard\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__